import React from 'react';

import sy from '~/styles';
import {Text} from '~/components/controls';

import {getDateLabel} from '../helper';
import PropTypes from 'prop-types';

const DateText = ({date}) => (
  <Text style={sy.mediumBold}>{getDateLabel(date)}</Text>
);
DateText.propTypes = {
  date: PropTypes.any,
};


export default DateText;
